// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d152809","239":"86b92176","453":"3bf14168","667":"e6a363f8"}[chunkId] + ".chunk.js";
};